import { render, staticRenderFns } from "./extra-request-tester.vue?vue&type=template&id=65942f04"
import script from "./extra-request-tester.vue?vue&type=script&lang=js"
export * from "./extra-request-tester.vue?vue&type=script&lang=js"
import style0 from "./extra-request-tester.vue?vue&type=style&index=0&id=65942f04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports